import { withTranslation } from "react-i18next";
import { AboutComponent } from "../../components/info/AboutComponent";
import { ContainerComponent } from "../../components/ui";

const AboutPage = () => {
  return (
    <ContainerComponent>
      <AboutComponent />
    </ContainerComponent>
  );
};

export default withTranslation()(AboutPage);
